
import React from 'react';
import content from '../data/content';
import '../styles/News.css';

function News() {
  const { news } = content;

  return (
    <section id="news" className="news-section">
      <div className="news-container">
        <h2>{news.title}</h2>
        <div className="news-items-container">
          {news.items.map((item, index) => (
            <div className="news-item" key={index}>
              <span className="news-date">{item.date}</span>
              <p className="news-text">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default News;
